<template>
  <router-view name="orderReports" v-bind:key="$route.path"></router-view>
</template>
<script>
export default {
  name: "OrderReports",
};
</script>